import React from 'react';
import { Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { validatePasswordPolicy } from '../../utils';

interface PasswordPolicyChecklistProps {
  password: string;
}

const PasswordPolicyChecklist: React.FC<PasswordPolicyChecklistProps> = ({ password }) => {
  const { t } = useTranslation();
  const { rules } = validatePasswordPolicy(password);

  return (
    <div className="flex flex-col gap-1 mt-1 mb-2">
      {rules.map((rule) => (
        <div key={rule.key} className="flex items-center gap-2 text-sm">
          <Icon style={{ fontSize: 18, color: rule.isValid ? '#16a34a' : '#9ca3af' }}>
            {rule.isValid ? 'check_circle' : 'radio_button_unchecked'}
          </Icon>
          <span className={rule.isValid ? 'text-green-700' : 'text-gray-500'}>{t(rule.labelKey)}</span>
        </div>
      ))}
    </div>
  );
};

export default PasswordPolicyChecklist;
